<template>
  <HeaderBlock v-show="isLoggedIn && !isGlobalLoading"></HeaderBlock>
  <div class="mt-50" v-show="isGlobalLoading">
    <span class="cssload-loader"><span class="cssload-loader-inner"></span></span>
  </div>
  <div :class="wrapper" v-show="!isGlobalLoading">
    <router-view :key="$route.path"></router-view>
    <FooterBlock v-if="isLoggedIn"></FooterBlock>
  </div>
</template>

<script>
import {loadProfile, isGlobalLoading, isLoggedIn} from "./inc/storage";
import 'bootstrap'
import "./scss/portal.scss"
import HeaderBlock from "@/components/layouts/HeaderBlock";
import FooterBlock from "@/components/layouts/FooterBlock";

export default {
  name: "App",
  components: {FooterBlock, HeaderBlock},
  created() {
    loadProfile()
  },
  setup() {
    return {
      isGlobalLoading, isLoggedIn
    }
  },
  computed : {
    wrapper : function ()
    {
      if (isLoggedIn.value)
      {
        return ['app-wrapper']
      }
      else {
        return ['app-auth-wrapper', 'row', 'g-0'];
      }
    }
  }
}
</script>

<style scoped>
.mt-50 {
  margin-top: 50px;
}
</style>

<style lang="css" src="./css/pm.css"></style>
<style lang="css" src="../node_modules/font-awesome/css/font-awesome.min.css"></style>
<style lang="scss" src="./scss/portal.scss"></style>
